
import Vue from "vue";
import rules from "@/services/helpers/validation-rules";

export default Vue.extend({
  name: "Create",

  data: () => ({
    rules,
    model: {
      accept_ata: false as boolean
    } as any,
    errorMessages: {} as { [value: string]: Array<string> },
    loading: false as boolean
  }),

  methods: {
    async submit(): Promise<void> {
      this.loading = true;
      try {
        if ((this.$refs.form as Vue).validate()) {
          await this.$API.expertiseTypes().create(this.model);
          await this.$router.push("/expertise-types");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global_alert.successful_create")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;

          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
      this.loading = false;
    }
  }
});
